import React, { Component } from 'react';
import { connect } from 'react-redux';
import MenuTitle from 'components/MenuTitle/MenuTitle';
import * as clevertapCapital from 'clevertap/capital';

import { pageRequestResult } from 'actions/capital/index';
import styles from './HeaderCapital.css';

class HeaderCapital extends Component {
  render() {
    const { showDashboardPage, menuTitle, isAllowToApply } = this.props;
    return (
      <div className={`hidden-xs hidden-sm col-md-12 ${styles['menu-title']}`}>
        <MenuTitle menuTitle={menuTitle} />
        {showDashboardPage && (
          <button
            className={`${
              styles['btn-apply-capital']
            } btn btn-primary pull-right`}
            disabled={!isAllowToApply}
            onClick={this._onClickApply}
          >
            Apply more Loan
          </button>
        )}
      </div>
    );
  }

  _onClickApply = () => {
    const { dispatch, borrowerProfile } = this.props;
    clevertapCapital.capitalClickApplyMore(borrowerProfile);
    dispatch(pageRequestResult(borrowerProfile));
  };
}

HeaderCapital.defaultProps = {};

function mapStateToProps(state) {
  const { borrowerProfile, isAllowToApply } = state.capital;
  return {
    borrowerProfile,
    isAllowToApply,
  };
}

export default connect(mapStateToProps)(HeaderCapital);
